import { render } from "./BackorderCatalogCartCont.vue?vue&type=template&id=c2a02508"
import script from "./BackorderCatalogCartCont.vue?vue&type=script&lang=js"
export * from "./BackorderCatalogCartCont.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__